module.exports = __webpack_public_path__ + "img/kl.a7c2407a.png";